exports = module.exports = require("../../../../../../node_modules/css-loader/lib/css-base.js")(false);
// imports


// module
exports.push([module.id, ".required-asterisk[data-v-ea998fb6] {\n  color: red;\n}\n.info-message[data-v-ea998fb6] {\n  display: flex;\n  align-items: center;\n}\n.info-message i[data-v-ea998fb6] {\n  padding-right: 15px;\n}\n.info-message p[data-v-ea998fb6] {\n  flex: 1;\n  margin-bottom: 0;\n}\n", ""]);

// exports
